




import { defineComponent } from '@vue/composition-api';
import AppRow from '@berlin-front/common/components/elements/AppRow';
import AppText from '@berlin-front/common/components/elements/AppText';
import AppLink from '@berlin-front/common/components/elements/AppLink';

// @vue/component
export default defineComponent({
  name: 'AuthFailDetailMyPage',
  components: {
    AppRow,
    AppText,
    AppLink,
  },

  setup() {
    return { ATONE_MY_PAGE_URL: process.env.VUE_APP_ATONE_MY_PAGE_LOGIN };
  },
});
